import React from "react";
import { MdFilterList, MdOutlineClear } from "react-icons/md";
import EAButton from "../../../shared/Buttons/EAButton";
import EAIconButton from "../../../shared/Buttons/EAIconButton";
import EAScheduleDatePicker from "../../../shared/EAScheduleDatePicker/EAScheduleDatePicker";
import EASelect from "../../../shared/EASelect/EASelect";
import CourtFiltersModal from "./CourtFiltersModal";
import useCourtBar from "./useCourtBar";
import { CourtGridCourt } from "../../../../models/CourtGridData";
import "./style.scss";

interface IProps {
  selectedDate: Date;
  setSelectedDate: (date: Date) => void;
  availableCourts: CourtGridCourt[];
  selectedCourts: string[];
  setSelectedCourts: (courts: string[]) => void;
  currentCourtIndex?: number;
  onPreviousCourt?: () => void;
  onNextCourt?: () => void;
  onCourtChange?: (courtIndex: number) => void;
  updateCourtFilters?: (selectedCourts: string[], availableCourts: string[]) => void;
  persistentSelectedCourts?: string[];
  exerciseName?: string;
}

const CourtBar: React.FC<IProps> = ({
  selectedDate,
  setSelectedDate,
  availableCourts,
  selectedCourts,
  setSelectedCourts,
  currentCourtIndex = 0,
  onPreviousCourt,
  onNextCourt,
  onCourtChange,
  updateCourtFilters,
  persistentSelectedCourts,
  exerciseName,
}) => {
  const {
    openFilters,
    setOpenFilters,
    isMobile,
    hasFiltersSelected,
    filteredCourts,
    currentCourtName,
    handleClearFilters,
  } = useCourtBar({
    selectedDate,
    setSelectedDate,
    availableCourts,
    selectedCourts,
    setSelectedCourts,
    currentCourtIndex,
  });

  const handleClearAllFilters = () => {
    if (updateCourtFilters) {
      // Przekaż pustą tablicę jako selectedCourts i dostępne korty jako availableCourts
      // To spowoduje wyczyszczenie zarówno bieżących jak i persystentnych filtrów
      updateCourtFilters(
        [],
        availableCourts.map((court) => court.courtName)
      );
    } else {
      handleClearFilters();
    }
  };

  return (
    <>
      <div className="court-bar">
        <div className="court-bar__section">
          {isMobile ? (
            <>
              <EAIconButton
                title="Filtry"
                icon={<MdFilterList />}
                variant="icon"
                onClick={() => setOpenFilters(true)}
              />
              {hasFiltersSelected && (
                <EAIconButton
                  title="Wyczyść filtry"
                  icon={<MdOutlineClear />}
                  variant="icon"
                  onClick={handleClearAllFilters}
                />
              )}
            </>
          ) : (
            <>
              <EAButton
                title={hasFiltersSelected ? "Wybrano filtry" : "Filtry"}
                onClick={() => setOpenFilters(true)}
                variant="outlined"
              />
              {hasFiltersSelected && (
                <EAButton
                  title="Wyczyść filtry"
                  onClick={handleClearAllFilters}
                  startIcon={<MdOutlineClear />}
                  variant="text"
                />
              )}
            </>
          )}
        </div>

        {isMobile && filteredCourts.length > 1 && (
          <div className="court-bar__court-navigation">
            <EASelect
              label=""
              name="court-select"
              value={currentCourtName}
              onChange={(e) => {
                const selectedCourtIndex = filteredCourts.findIndex((court) => court.courtName === e.target.value);
                if (selectedCourtIndex !== -1 && onCourtChange) {
                  onCourtChange(selectedCourtIndex);
                }
              }}
              options={filteredCourts.map((court) => ({
                value: court.courtName,
                label: court.courtName,
              }))}
              placeholder="Wybierz kort"
            />
          </div>
        )}

        <div className="court-bar__section">
          <EAScheduleDatePicker selectedDate={selectedDate} onDateChange={setSelectedDate} requireConfirmation={true} />
        </div>
      </div>

      {openFilters && (
        <CourtFiltersModal
          open={openFilters}
          setOpen={setOpenFilters}
          availableCourts={availableCourts}
          selectedCourts={selectedCourts}
          setSelectedCourts={setSelectedCourts}
          updateCourtFilters={updateCourtFilters}
          persistentSelectedCourts={persistentSelectedCourts}
          exerciseName={exerciseName}
        />
      )}
    </>
  );
};

export default CourtBar;
